<script>
export default {
  name: 'WarningMessage',
  props: {
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<template>
  <div 
    :class="{ 
      'inv-warning--success': success,
      'inv-warning--error': error,
    }" 
    class="inv-warning"
  >
    <slot/>
  </div>
</template>
